var path = 'templates/dialogs/likes.html';
var html = "<md-dialog class=\"likes dialog\" aria-label=likes style=width:50%> <md-toolbar> <div class=md-toolbar-tools> <h2>あっぱれ！</h2> </div> </md-toolbar> <md-dialog-content layout=column style=height:500px> <md-content style=width:100%> <md-list style=width:100%> <md-list-item class=\"\" style=padding-bottom:5px ng-repeat=\"(uid, liked) in likes\" ng-if=liked ng-init=\"user = Users.get(uid)\"> <img open-profile=user alt=\"{{user.name }}\" ng-src={{user.avatar}} class=md-avatar /> <p open-profile=user>{{ user.name }}</p> </md-list-item> </md-list> </md-content> </md-dialog-content> </md-dialog> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/dialogs/likes.html
// module id = 10
// module chunks = 0